<script>
import echarts from 'echarts/lib/echarts'
export default {
  functional: true,
  render(
    h,
    {
      props: { option = {}, data = [] }
    }
  ) {
    const maxValue = Math.max(...data.map(v => v.value))
    const xAxisData = ['1星', '2星', '3星', '4星', '5星']
    const colorData = data.slice().map((v, i) => {
      v.itemStyle = {
        normal: {
          color:
            v.value === maxValue
              ? new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#FFEE3D'
                },
                {
                  offset: 1,
                  color: '#E53C3D'
                }
              ])
              : new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: '#68EAD0'
                },
                {
                  offset: 1,
                  color: '#459EEF'
                }
              ]),
          opacity: 1
        }
      }
      return v
    })
    return (
      <bar-charts option={option} data={colorData} x-axis-data={xAxisData} />
    )
  }
}
</script>
